import { CommonModule } from '@angular/common';
// This Module's Components
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AcctactvtyModule } from '../acctactvty/acctactvty.module';
import { FlyoutFeedComponent } from './flyout-feed.component';

@NgModule({ declarations: [FlyoutFeedComponent],
    exports: [FlyoutFeedComponent], imports: [CommonModule,
        AcctactvtyModule,
        ModalModule.forRoot(),
        TabsModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class FlyoutFeedModule {}
